/**
 * @desc 导出
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.demandOrder.exportExcel.Params, options?: any) {
  return updateResponse(
    http(URL + `/wms/demandOrder/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
